import React from "react";
import { SvgIcon } from "@material-ui/core";

const NetworkIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 68 60">
      <path
        id="Path_4184"
        data-name="Path 4184"
        d="M0,0H16V60H0Z"
        transform="translate(52)"
      />
      <path
        id="Path_4185"
        data-name="Path 4185"
        d="M0,0H16V40H0Z"
        transform="translate(26 20)"
      />
      <path
        id="Path_4186"
        data-name="Path 4186"
        d="M0,0H16V20H0Z"
        transform="translate(0 40)"
      />
    </SvgIcon>
  );
};

export default NetworkIcon;
